import {
  apiRequest,
  penilaianTunjanganKhususList,
  penilaianTunjanganKhususActive,
  penilaianTunjanganKhususInactive,
  penilaianTunjanganKhususGenerate,
  penilaianTunjanganKhususVerifikasi,
  exportExcel,
  masterWorkUnit,
  listAtasan,
  detailBobot,
  penilaianTunjanganKhususListPosition,
  penilaianTunjanganKhususUpdatePosition,
  penilaianTunjanganKhususDeleteData,
  sendNotification,
  clearSpecialAllowance,
} from "../../../../../services/adapters/kepegawaian/penilaianTunjanganKhususService";

class DataTableRepository {
  fetchRowTable = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      penilaianTunjanganKhususList,
      {
        cancelToken: cancelToken,
        params: query,
      },
      true
    );
  };

  fetchWorkUnit = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      masterWorkUnit,
      {
        cancelToken: cancelToken,
        params: query,
      },
      true
    );
  };

  fetchAtasan = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      listAtasan,
      {
        cancelToken: cancelToken,
        params: query,
      },
      true
    );
  };

  fetchInactive = async (query) => {
    return await apiRequest(
      "post",
      penilaianTunjanganKhususInactive,
      {
        body: query,
      },
      true
    );
  };

  fetchActive = async (query) => {
    return await apiRequest(
      "post",
      penilaianTunjanganKhususActive,
      {
        body: query,
      },
      true
    );
  };

  fetchGenerate = async (query) => {
    return await apiRequest(
      "get",
      penilaianTunjanganKhususGenerate,
      {
        params: query,
      },
      true
    );
  };

  fetchVerifikasi = async (query) => {
    return await apiRequest(
      "get",
      penilaianTunjanganKhususVerifikasi,
      {
        params: query,
      },
      true
    );
  };

  fetchExport = async (query) => {
    return await apiRequest(
      "get",
      exportExcel,
      {
        params: query,
      },
      true
    );
  };

  fetchBobot = async (query) => {
    return await apiRequest(
      "get",
      detailBobot,
      {
        params: query,
      },
      true
    );
  };

  fetchPosition = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      penilaianTunjanganKhususListPosition,
      {
        cancelToken: cancelToken,
        params: query,
      },
      true
    );
  };

  updatePosition = async (query) => {
    return await apiRequest(
      "post",
      penilaianTunjanganKhususUpdatePosition,
      {
        body: query,
      },
      true
    );
  };

  sendNotification = async (query) => {
    return await apiRequest(
      "get",
      sendNotification,
      {
        params: query,
      },
      true
    );
  };

  deleteTunsus = async (query) => {
    return await apiRequest(
      "post",
      penilaianTunjanganKhususDeleteData,
      {
        body: query,
      },
      true
    );
  };

  fetchClearSpecialAllowance = async (query) => {
    return await apiRequest(
      "post",
      clearSpecialAllowance,
      {
        body: query,
      },
      true
    );
  };
}

export default DataTableRepository;
